/**
 * Compound Operation Grouping Rules
 * Handles grouping for batch operations and complex multi-step operations
 */

import { Operation, NodeOperation } from '@/shared/types/projectData';
import { GroupingRule } from './transformRules';

export const compoundRules: Record<string, GroupingRule> = {
  // Batch operations
  'batch-update': {
    opensGroup: 'compound',
    name: (op: Operation) => {
      const count = (op as NodeOperation).updates?.length || 1;
      return `Batch update ${count} items`;
    },
    canMerge: false // Batch operations should not merge
  },

  'batch-delete': {
    opensGroup: 'compound',
    name: (op: Operation) => {
      const count = (op as NodeOperation).nodeIds?.length || 1;
      return `Delete ${count} items`;
    },
    canMerge: false
  },
};
